import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Siempre me angustiaba pensar qué pasaría con las miles de fotos de mis nietos que tengo en el iPad. Con esta guía, en una tarde dejé todo organizado en una carpeta física. Dormí tranquila por primera vez en meses.',
  name: 'María G.',
  age: '68 años'
}, {
  quote: 'Mis hijos siempre me regañaban por anotar mis contraseñas en papelitos sueltos. El organizador que viene aquí es perfecto porque la letra es grande y el sistema es muy seguro. No necesité saber nada de computación.',
  name: 'Carmen L.',
  age: '72 años'
}];
export function Testimonials() {
  return <section className="py-20 px-6 md:px-12 lg:px-24 bg-cream" data-id="element-160">
      <div className="max-w-5xl mx-auto" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-163">
            Mujeres como tú ya han protegido su legado
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-164">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-10 rounded-2xl shadow-sm border border-cream-dark relative" data-id="element-165">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-gold/20" data-id="element-166" />
              <p className="text-xl text-navy-light italic mb-8 relative z-10 leading-relaxed" data-id="element-167">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-168">
                <div className="w-14 h-14 bg-navy text-gold rounded-full flex items-center justify-center font-playfair text-2xl font-bold" data-id="element-169">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-170">
                  <p className="font-bold text-navy text-lg" data-id="element-171">
                    {testimonial.name}
                  </p>
                  <p className="text-navy-light" data-id="element-172">{testimonial.age}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}